export const STAND_QA_VERSION = "1.3.0";
